import { Calendar, Phone, MapPin } from "lucide-react";
import { fmtDate } from "@/lib/formatters";

/** Top section: avatar (initials) + identity + quick contact info. */
export default function PatientHeader({ patient }) {
  const initials = (patient.full_name || "?")
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <div className="flex items-start gap-4 flex-wrap">
      <div className="h-14 w-14 rounded-full bg-blue-700 text-white text-xl font-display font-semibold flex items-center justify-center">
        {initials}
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-mono text-xs text-slate-500">{patient.internal_id}</div>
        <h1 className="font-display text-2xl font-bold text-slate-900">{patient.full_name}</h1>
        {patient.social_name && <div className="text-sm text-slate-500">Nome social: {patient.social_name}</div>}
        <div className="flex gap-4 flex-wrap text-xs text-slate-500 mt-2">
          <span><Calendar className="h-3 w-3 inline mr-1" />{fmtDate(patient.birth_date)}</span>
          <span><Phone className="h-3 w-3 inline mr-1" />{patient.phone || "—"}</span>
          <span><MapPin className="h-3 w-3 inline mr-1" />{[patient.city, patient.state].filter(Boolean).join("/") || "—"}</span>
        </div>
      </div>
    </div>
  );
}
